export default "__VITE_ASSET__6NIpTTYhMTSsh1yxCxdlpQ__"